import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import Button from '@mui/material/Button'
import { useNavigate } from "react-router-dom";
import paths from "../../Infrastructure/Router/paths";
import { learnerFaqSx } from "./styles";

const faqData = [
  {
    question: "Where do classes happen?",
    answer: "All of our classes take place online through our built in video conferencing software"
  },
  {
    question: "When do classes happen?",
    answer: "The class schedule for a given course is set by the instructor for that specific class. You can view the available classes under the “Classes” section in the course page of a given course. Once you are enrolled in a course, you can view your enrolled classes, including class information, in the Dashboard."
  },
  {
    question: "Do I have to apply to enroll in a course? Is there an admissions process?",
    answer: "No there is no admissions process and no need to apply for a course. Simply create a learner account, pick a class, and sign up instantly. We welcome all learners that follow our Code of Conduct."
  },
  {
    question: "How much do courses cost?",
    answer: "Course prices are set by instructors and vary from course to course."
  },
  {
    question: "Are there any requirements to enroll in a course?",
    answer: "Learners must have the ability to join video conferencing sessions and accept the terms of service. There may be additional requirements for some courses which will be listed on the course page."
  },
  {
    question: "What if I don't like the course and want to drop out?",
    answer: "Learners can drop the course after the first session for any reason and receive a full refund. Course fees are not refundable after the second session."
  },
  {
    question: "Who are the Educators?",
    answer: "Course instructors are independent practitioners who are offering courses on the Vulcan Learning Platform. These instructors are thoroughly vetted to ensure a quality experience for learners. Educators choose their own course material and set the schedules of their classes. The Vulcan Platform does not control or dictate Educator content, methods, schedule, or conduct."
  },
  {
    question: "How are the Educators on the Vulcan Platform selected?",
    answer: "Educators on the Vulcan Platform go through a thorough application process to evaluate the qualifications and fit before they are allowed to offer a course on the Vulcan Platform. Not all applicants are accepted and Educators may be removed from the platform if conduct or performance do not meet our standards."
  }
];

const LearnerFaq = () => {
  const navigate = useNavigate();
  return (
    <Box sx={learnerFaqSx.page}>
      <Typography variant="h1" align="center" component="h2" sx={learnerFaqSx.title}>
        Learner FAQ
      </Typography>
      {faqData.map((faq, index) => (
        <Accordion key={index}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon fontSize="small" />}
            aria-controls={`panel${index + 1}a-content`}
            id={`panel${index + 1}a-header`}
          >
            <Typography variant="subtitle1">{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="subtitle2">{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
      <Box sx={learnerFaqSx.ctaWrapper}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(paths.coursesPage.path)}
          sx={learnerFaqSx.ctaButton}
        >
          Courses
        </Button>
      </Box>

    </Box>
  );
};

export default LearnerFaq;
